export default __webpack_public_path__ + "static/media/putting-coin-in-investment.78fc7469.svg";